import {
  Divider,
  Button,
  Table,
  Modal,
  Form,
  Tooltip,
  Space,
  Popconfirm,
  Input,
  message,
  InputNumber,
} from "antd";
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import * as Helper from "../../helpers";
import { deleteSure, getSureler, insertSure, updateSure } from "../../store/slices/sureSlice";
const Sureler = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getSureler({
      sort: [
        {
          field: "DizilisSirasi",
          dir: "asc",
        },
      ],
    }));
  }, [dispatch]);

  const sure = useSelector((state) => state.sure);
  const sureler = useSelector((state) => state.sure.sureler);

  
  const [filteredInfo, setFilteredInfo] = useState({});
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editMode, setEditMode] = useState(false);

  const [form] = Form.useForm();

  const showModal = () => {
    form.resetFields();
    setEditMode(false);
    setIsModalVisible(true);
  };

  const handleEdit = (record) => {
    setEditMode(true);
    form.setFieldsValue({
      id: record.id,
      isim: record.isim,
      dizilisSirasi: record.dizilisSirasi,
      inisSirasi: record.inisSirasi,
      ayetSayisi: record.ayetSayisi,
    });
    setIsModalVisible(true);
  };

  const handleOk = () => {
    form
      .validateFields()
      .then((record) => {
        if (editMode) {
          let body = {
            id: record.id,
            isim: record.isim,
            dizilisSirasi: record.dizilisSirasi,
            inisSirasi: record.inisSirasi,
            ayetSayisi: record.ayetSayisi,
          };
          dispatch(updateSure(body))
            .unwrap()
            .then((result) => {
              dispatch(getSureler({
                sort: [
                  {
                    field: "DizilisSirasi",
                    dir: "asc",
                  },
                ],
              }));
              setIsModalVisible(false);
              form.resetFields();
              setEditMode(false);
              message.success("Sure güncellendi");
            })
            .catch(() => {
              // handle error here
            });
        } else {
            let body = {
                isim: record.isim,
                dizilisSirasi: record.dizilisSirasi,
                inisSirasi: record.inisSirasi,
                ayetSayisi: record.ayetSayisi,
              };
              dispatch(insertSure(body))
                .unwrap()
                .then((result) => {
                  dispatch(getSureler({
                    sort: [
                      {
                        field: "DizilisSirasi",
                        dir: "asc",
                      },
                    ],
                  }));
                  setIsModalVisible(false);
                  form.resetFields();
                  setEditMode(false);
                  message.success("Sure eklendi");
                })
                .catch(() => {
                  // handle error here
                });

        }
      })
      .catch((info) => {});
  };

  const handleDelete = (id) => {
    let body= {id:id}
    dispatch(deleteSure(body)).unwrap().then((result) => {
        dispatch(getSureler({
          sort: [
            {
              field: "DizilisSirasi",
              dir: "asc",
            },
          ],
        }));
        message.success("Sure silindi")
    })
        .catch((rejectedValueOrSerializedError) => {
            // handle error here
        })

  };

  const handleCancel = () => {
    form.resetFields();
    setIsModalVisible(false);
  };

  const handleChange = (pagination, filters, sorter) => {
    setFilteredInfo(filters);
  };

  return (
    <div>
      <Button
        onClick={() => showModal()}
        type="primary"
        style={{
          marginBottom: 16,
        }}
      >
        Ekle
      </Button>
      <Divider />

      <Table
        loading={sure.loading}
        dataSource={sureler.items}
        rowKey="id"
        onChange={handleChange}
        columns={[
          {
            title: "Id",
            dataIndex: "id",
            key: "id",
          },
          {
            title: "Sure İsmi",
            dataIndex: "isim",
            key: "isim",
            filters: Helper.filter(sureler.items, "isim"),
            filteredValue: filteredInfo.isim || null,
            onFilter: (value, record) => record.isim.includes(value),
            filterSearch: true,
            filterMultiple: true,
            ellipsis: true,
            sorter: (a, b) => a.isim.length - b.isim.length,

          },
          {
            title: "Ayet Sayısı",
            dataIndex: "ayetSayisi",
            key: "ayetSayisi",
            filters: Helper.filter(sureler.items, "ayetSayisi"),
            filteredValue: filteredInfo.ayetSayisi || null,
            onFilter: (value, record) => record.ayetSayisi.includes(value),
            filterSearch: true,
            filterMultiple: true,
            ellipsis: true,
            sorter: (a, b) => a.ayetSayisi - b.ayetSayisi

          },
          {
            title: "Diziliş Sırası",
            dataIndex: "dizilisSirasi",
            key: "dizilisSirasi",
            filters: Helper.filter(sureler.items, "dizilisSirasi"),
            filteredValue: filteredInfo.dizilisSirasi || null,
            onFilter: (value, record) => record.dizilisSirasi.includes(value),
            filterSearch: true,
            filterMultiple: true,
            ellipsis: true,
            sorter: (a, b) => a.dizilisSirasi - b.dizilisSirasi

          },
          {
            title: "İniş Sırası",
            dataIndex: "inisSirasi",
            key: "inisSirasi",
            filters: Helper.filter(sureler.items, "inisSirasi"),
            filteredValue: filteredInfo.inisSirasi || null,
            onFilter: (value, record) => record.inisSirasi.includes(value),
            filterSearch: true,
            filterMultiple: true,
            ellipsis: true,
            sorter: (a, b) => a.inisSirasi - b.inisSirasi

          },
          {
            key: "action",
            render: (_, record) => (
              <Space size="middle">
                <Tooltip title="Düzenle">
                  <Button
                    onClick={() => handleEdit(record)}
                    type="primary"
                    shape="circle"
                    icon={<EditOutlined />}
                  />
                </Tooltip>
                <Popconfirm
                  title="Sureyi Silmek İstediğinize Emin Misiniz ?"
                  onConfirm={() => handleDelete(record.id)}
                  okText="Evet"
                  cancelText="Hayır"
                >
                  <Tooltip title="Sil">
                    <Button
                      type="primary"
                      danger
                      shape="circle"
                      icon={<DeleteOutlined />}
                    />
                  </Tooltip>
                </Popconfirm>
              </Space>
            ),
          },
        ]}
      />

      <Modal
        title="Ekle"
        onCancel={handleCancel}
        visible={isModalVisible}
        footer={[
          <Button key="back" onClick={handleCancel}>
            Vazgeç
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={sure.loading}
            onClick={handleOk}
          >
            Kaydet
          </Button>,
        ]}
      >
        <Form
          name="basic"
          form={form}
          labelCol={{
            span: 6,
          }}
          initialValues={{ remember: true }}
          autoComplete="on"
        >
          <Form.Item hidden={true} name="id">
            <Input />
          </Form.Item>
          <Form.Item
            label="Sure Ismi"
            name="isim"
            rules={[{ required: true, message: "Sure ismi boş geçilemez" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Ayet Sayısı"
            name="ayetSayisi"
            rules={[{ required: true, message: "Ayet boş geçilemez" }]}
          >
            <InputNumber min={1} />
          </Form.Item>
          <Form.Item
            label="Diziliş Sırası"
            name="dizilisSirasi"
            rules={[
              { required: true, message: "Diziliş sırası boş geçilemez" },
            ]}
          >
            <InputNumber  min={1} />
          </Form.Item>
          <Form.Item
            label="İniş Sırası"
            name="inisSirasi"
            rules={[{ required: true, message: "İniş sırası boş geçilemez" }]}
          >
            <InputNumber   min={1}/>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default Sureler;
